module.exports = __webpack_public_path__ + "img/SINOTRUK.4023a492.svg";